import React from 'react'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { settingSetGuarantor } from 'services/setting'
import posthog from 'posthog-js'

export default function useSetGuarantor(refetch: () => void) {
    const { isLoading, mutate } = useMutation({
        // Same legacy view as the role modals: a refusal is HTTP 200 with a
        // non-2050 `code`, which used to toast «با موفقیت تغییر یافت».
        mutationFn: async (payload: ISetGuarantorSettingPayload) => {
            const data = await settingSetGuarantor(payload)
            if (typeof data?.code === 'number' && data.code !== 2050) {
                throw Object.assign(new Error('poolship update refused'), {
                    code: data.code,
                })
            }
            return data
        },
        onSuccess: (data, variables: any) => {
            posthog.capture('member_guarantor_changed', {
                fund_id: variables?.id ?? variables?.moneyPool,
                poolship_id: variables?.poolShip,
            })
            refetch()
            toast.success('با موفقیت تغییر یافت')
        },
        onError: (error: any, variables: any) => {
            posthog.capture('member_action_failed', {
                action: 'change_guarantor',
                fund_id: variables?.id ?? variables?.moneyPool,
                poolship_id: variables?.poolShip,
                status: error?.response?.status,
                code: error?.code,
            })
            toast.error('مشکلی پیش آمده!')
        },
    })

    return { mutate }
}
